const RESPONSIVE = {
  SM: {
    UP: 576,
    DOWN: 575.99,
  },
  MD: {
    UP: 768,
    DOWN: 767.99,
  },
  LG: {
    UP: 992,
    DOWN: 991.99,
  },
  XL: {
    UP: 1200,
    DOWN: 1199.99,
  },
  XS: {
    UP: 468,
    DOWN: 467.99,
  },
}

export default RESPONSIVE
